var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#0074BC;}\r\n\t.st2{fill:#E2E3E4;}\r\n\t.st3{fill:#EA4334;}\r\n\t.st4{fill:#EC5C4F;}\r\n\t.st5{fill:#F4C647;}\r\n\t.st6{fill:#F8BB16;}\r\n\t.st7{fill:#CD3D31;}\r\n\t.st8{fill:#ECA119;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GCP_tech"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.9,37.6c4.1-0.6,7.9,2.1,8.5,6.2c0,0.2,0.1,0.4,0.1,0.6c0.2,2.4-0.7,4.8-2.6,6.4 c-1.8,1.5-4.1,2.1-6.4,1.6c-1.1-0.2-2.1-0.7-3.1-1.4c-3.3-2.5-3.9-7.2-1.4-10.5C60.2,39,61.9,37.9,63.9,37.6L63.9,37.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_0074bcff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.9,20.1c0.6-0.1,1.3-0.2,1.9-0.1h23.2c0.9,0,1.8,0.3,2.5,0.9c0.5,0.4,0.9,1,1.2,1.6L85,30h-0.2 c-3.8,0-7.5,0-11.3,0H56.3c-2.7,4.7-5.4,9.4-8.1,14.1c-0.1,0.3-0.3,0.6-0.5,0.8c-1.9-3.3-3.8-6.6-5.7-9.9 c2.6-4.4,5.1-8.8,7.6-13.3C50.2,20.9,51,20.4,51.9,20.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_e2e3e4ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.3,30h17.3c2.8,5,5.7,10,8.6,15c-4.6,8.1-9.3,16.1-13.9,24.2l-0.3,0.4c1.8-3.2,3.7-6.4,5.5-9.6 c-5.7,0-11.5,0-17.2,0c-1.3-2.1-2.5-4.3-3.7-6.4c-1.6-2.9-3.3-5.8-5-8.7c0.2-0.2,0.4-0.5,0.5-0.8C50.9,39.5,53.7,34.8,56.3,30  M63.9,37.7c-4.1,0.7-6.9,4.5-6.2,8.6c0.3,1.9,1.3,3.6,2.9,4.8c2.8,2.1,6.7,2,9.4-0.3c1.8-1.6,2.8-4,2.6-6.4 c-0.3-4.1-3.9-7.2-8-6.9C64.3,37.6,64.1,37.6,63.9,37.7L63.9,37.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_ea4334ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.7,30c3.8,0,7.5,0,11.3,0v0.3c-3.6,0-7.3,0-10.9,0h10.9l0.2,0.4c0.5,1,1,2,1.6,2.9 c1.4,2.6,2.9,5.1,4.4,7.7c0.8,1.1,1.4,2.3,1.8,3.6c-0.2,0.9-0.6,1.8-1.1,2.7c-0.8,1.2-1.4,2.5-2.1,3.7c-0.9,1.7-1.9,3.4-2.9,5.1 c-0.8,1.2-1.4,2.6-2.2,3.8c-1.2,2.3-2.6,4.5-3.8,6.8c-0.4,1-1.2,1.8-2.2,2.2c-0.9,0.2-1.8,0.3-2.7,0.2h-6.4 c-0.4,0-0.7,0-1.1-0.1c4.6-8.1,9.3-16.1,13.9-24.2C79.4,40.1,76.5,35,73.7,30z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_ec5c4fff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.9,30h0.2c2.5,4.3,4.9,8.6,7.4,12.9c0.2,0.4,0.4,0.7,0.5,1.2c-0.1,0.3-0.1,0.6-0.2,1 c-0.4-1.3-1-2.6-1.8-3.7c-1.4-2.6-2.9-5.1-4.4-7.7c-0.6-0.9-1.1-1.9-1.6-2.9c-0.1-0.1-0.1-0.3-0.1-0.4 C84.9,30.3,84.9,30.1,84.9,30z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_f4c647ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37.5,43c1.5-2.6,3-5.3,4.5-7.9c1.9,3.3,3.8,6.6,5.7,9.9c1.6,2.9,3.4,5.8,5,8.7c-0.3-0.3-0.6-0.7-0.8-1.1 c-3.2-5.6-6.5-11.2-9.7-16.8c-0.2,0.2-0.4,0.4-0.5,0.7c-1.5,2.8-3.2,5.5-4.7,8.3C37,44.1,37.1,43.5,37.5,43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_f8bb16ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M41.6,36.4c0.1-0.3,0.3-0.5,0.5-0.7c3.2,5.6,6.5,11.2,9.7,16.8c0.2,0.4,0.5,0.8,0.8,1.1 c1.3,2.1,2.4,4.3,3.7,6.4c5.7,0,11.5,0,17.2,0c-1.8,3.2-3.7,6.4-5.5,9.6C68,69.7,68,69.8,67.9,70c-4.9,0-9.8,0-14.8,0 c-1,0.1-2-0.3-2.8-1c0.4,0.1,0.7,0.3,1.1,0.4c0.5,0.2,1.1,0.3,1.6,0.3c4.2,0,8.3,0,12.5,0c0.7,0,1.4,0,2.1-0.1 c0-0.1,0-0.2,0.1-0.3c-4.6,0-9.3,0-13.9,0c-1.2,0.2-2.4-0.1-3.4-0.8c-0.8-0.7-1.4-1.6-1.8-2.6c-1.8-3-3.5-6.1-5.3-9.1 c-1.8-3.3-3.8-6.5-5.6-9.8c-0.2-0.5-0.5-1-0.8-1.5c0-0.3,0-0.6,0-0.9C38.4,41.9,40.1,39.2,41.6,36.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_cd3d31ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M92.8,45c0.1-0.3,0.2-0.6,0.2-1c0.2,0.9,0.1,1.9-0.4,2.8L80.5,68c-0.7,1.2-1.9,2-3.3,2h-9.3l0.2-0.4 c0.1-0.1,0.2-0.2,0.3-0.4c0.3,0,0.7,0.1,1.1,0.1h6.4c0.9,0.1,1.8,0,2.7-0.2c1-0.4,1.8-1.2,2.2-2.2c1.2-2.3,2.5-4.5,3.8-6.7 c0.8-1.2,1.4-2.6,2.1-3.8c0.9-1.7,2-3.4,2.9-5.1c0.8-1.2,1.4-2.5,2.1-3.7C92.1,46.8,92.5,45.9,92.8,45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_eca119ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.9,45.6c0.3,0.5,0.6,1,0.8,1.5c1.9,3.3,3.8,6.5,5.6,9.8c1.8,3,3.5,6.1,5.3,9.1c0.4,1,1,1.9,1.8,2.6 c1,0.7,2.2,1,3.4,0.8c4.6,0,9.3,0,13.9,0c0,0.1-0.1,0.2-0.1,0.3c-0.7,0.1-1.5,0.1-2.2,0.1H53c-0.6,0-1.1-0.1-1.6-0.3 c-0.3-0.2-0.7-0.3-1.1-0.4c-0.4-0.3-0.7-0.7-0.9-1.1c-4-7-8-14-12-21C37.2,46.6,37,46.1,36.9,45.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/GCP.7d8c1494891da07d78eb503d47227c6f.svg";
export { ForwardRef as ReactComponent };